import { useController } from '@rest-hooks/react';

import OrderResource from 'resources/user/OrderResource'

import { useError } from './useErrorController';
import { parseErrorMessages } from './parseErrorMessages';

const usePaymentIntent = ({
  handleValidation,
  userPhone,
  object,
  pricingId,
  requestedAmount,
  promoCode,
  handleStripeCardPaymentIntent,
  handleEupagoPaymentIntent,
  handlePaypalPaymentIntent,
  cartItems,
  shippingAddress,
  onShippingAddressRequired,
}) => {

  const { handleError, setLoading, validate } = useError();
  const { fetch } = useController();

  const createPaymentIntent = async (activeProvider, paymentMethod) => {
    try {

      if (paymentMethod === "mbway") validate(userPhone, handleValidation);

      setLoading(true);

      let params;

      if (cartItems && cartItems.length > 0) {
        params = {
          payment_provider: activeProvider,
          items: cartItems.map(ci => ({
            pricing_id: ci.product.pricing_id,
            amount: ci.amount,
            event_product_listing_id: ci.product.event_product_listing_id,
            product_variant_id: ci.variant?.id,
          })),
          user_phone: userPhone,
        };
      } else {
        params = {
          payment_provider: activeProvider,
          pricing_id: pricingId,
          amount: requestedAmount,
          user_phone: userPhone,
          promo_code: promoCode
        };
        if (object?.event_product_listing_id) {
          params.event_product_listing_id = object.event_product_listing_id;
        }
        if (object?.selected_variant) {
          params.product_variant_id = object.selected_variant.id;
        }
      }

      if (paymentMethod) params.payment_method = paymentMethod;
      if (shippingAddress) params.shipping_address = shippingAddress;

      const response = await fetch(OrderResource.create(), {organization_id: object.organization.id}, params);

      const {client_secret, id, items, stripe_account_id, stripe_publishable_key} = response;
      const firstItem = items?.[0];

      switch (activeProvider) {
        case "stripe":
          await handleStripeCardPaymentIntent(client_secret, stripe_publishable_key, stripe_account_id, id, firstItem?.unit_price, firstItem?.amount);
          break;
        case "eupago":
          await handleEupagoPaymentIntent(id, client_secret);
          break;
        case "paypal":
          handlePaypalPaymentIntent(id);
          return id;
      }

    } catch (error) {
      // A stale cart snapshot can miss a product's `deliverable` flag, so the
      // client never asked for an address and the server rejected the order.
      // A cart caller can recover by revealing the address step directly.
      if (onShippingAddressRequired && error.response?.status === 422) {
        const messages = await parseErrorMessages(error);
        if (messages.some((message) => message.toLowerCase().includes('shipping address'))) {
          setLoading(false);
          onShippingAddressRequired();
          return;
        }
        handleError(messages, true);
        return;
      }
      handleError(error);
    }
  };

  return { createPaymentIntent };
};

export default usePaymentIntent;
